/*
 * Copyright (c) 2025 NoorWays. All rights reserved.
 * Licensed under the terms specified in the LICENSE.txt file.
 */

/**
 * Environment-based configuration loader for the web client.
 *
 * Priority order for configuration values:
 * 1) import.meta.env (Vite environment variables)
 * 2) Optional defaults provided by callers
 *
 * Security: No runtime configuration files are used to prevent
 * exposure of configuration patterns to browsers.
 */

/**
 * Resolves a config value from environment variables.
 *
 * @param key - The environment variable key to look up
 * @param fallback - Optional fallback value if the environment variable is not set
 * @returns The resolved configuration value or undefined
 */
export function getConfigValue(key: string, fallback?: string): string | undefined {
  // Direct access to import.meta.env
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const env = import.meta.env as any
  const value = env?.[key]

  if (value !== undefined && value !== null) {
    const stringValue = String(value)
    // Skip placeholder values that weren't replaced by deployment pipeline
    if (stringValue !== '' && !stringValue.startsWith('#{') && !stringValue.endsWith('}#')) {
      return stringValue
    }
  }

  return fallback
}
